var _defs, _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(100%, 100%, 100%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(81.17981%, 42.349243%, 18.429565%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.63381, 62.265422)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.140625 -10.328125 L 10.515625 -14.859375 C 11.691406 -10.910156 14.734375 -8.9375 19.640625 -8.9375 C 21.785156 -8.9375 23.5625 -9.648438 24.96875 -11.078125 C 26.375 -12.503906 27.078125 -14.304688 27.078125 -16.484375 C 27.078125 -18.671875 26.394531 -20.46875 25.03125 -21.875 C 23.664062 -23.28125 22.023438 -24.253906 20.109375 -24.796875 C 18.203125 -25.347656 16.03125 -25.625 13.59375 -25.625 C 10.15625 -25.625 7.195312 -25.078125 4.71875 -23.984375 L 9.0625 -51.953125 L 35.578125 -51.953125 L 35.578125 -41.5625 L 19.203125 -41.5625 L 18.078125 -34.3125 C 18.203125 -34.3125 18.429688 -34.320312 18.765625 -34.34375 C 19.097656 -34.363281 19.347656 -34.375 19.515625 -34.375 C 22.160156 -34.375 24.5625 -34.082031 26.71875 -33.5 C 28.882812 -32.914062 30.921875 -31.972656 32.828125 -30.671875 C 34.742188 -29.367188 36.238281 -27.476562 37.3125 -25 C 38.382812 -22.519531 38.921875 -19.5625 38.921875 -16.125 C 38.921875 -11.164062 37.101562 -7.082031 33.46875 -3.875 C 29.832031 -0.664062 25.222656 0.9375 19.640625 0.9375 C 14.566406 0.9375 10.492188 -0.160156 7.421875 -2.359375 C 4.359375 -4.566406 2.265625 -7.222656 1.140625 -10.328125 Z M 1.140625 -10.328125 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.f8819816b4640c1770e6e8836c9411c0.svg";
export { ForwardRef as ReactComponent };